import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "children-table__row" }
const _hoisted_2 = { class: "children-table__row-col col-name" }
const _hoisted_3 = { class: "children-table__row-col col-height" }
const _hoisted_4 = { class: "children-table__row-col col-weight" }
const _hoisted_5 = { class: "children-table__row-col col-other" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.childName), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_text_field, {
        modelValue: _ctx.localHeight,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localHeight) = $event)),
          _ctx.emitHeight
        ],
        modelModifiers: { number: true },
        density: "compact",
        "hide-details": "",
        variant: "outlined",
        type: "number",
        suffix: "cm"
      }, null, 8, ["modelValue", "onUpdate:modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_text_field, {
        modelValue: _ctx.localWeight,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localWeight) = $event)),
          _ctx.emitWeight
        ],
        modelModifiers: { number: true },
        density: "compact",
        "hide-details": "",
        variant: "outlined",
        type: "number",
        suffix: "kg"
      }, null, 8, ["modelValue", "onUpdate:modelValue"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_v_text_field, {
        modelValue: _ctx.localRemarks,
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localRemarks) = $event)),
          _ctx.emitRemarks
        ],
        density: "compact",
        "hide-details": "",
        variant: "outlined"
      }, null, 8, ["modelValue", "onUpdate:modelValue"])
    ])
  ]))
}